<style rel="stylesheet/scss" lang="scss" scoped="scoped">
.newsDetail {
  width: 1000px;
  margin:0 auto;
  padding-top: 64px;
  .newsContents {
    padding: 0 40px;
    .title {
      margin: 0px auto 40px;
      text-align: center;
    }
    .imgUrl {
      display: block;
      max-width: 100%;
      margin: 0 auto;
      margin-bottom: 10px;
    }
    .textContent {
      line-height: 30px;
      img {
        max-width: 100%;
        margin: 10px 0;
      }
      h2 {
        font-size: 16px;
      }
    }
  }
}
</style>
<template>
  <div>

    <Head :selectindex="selectindex"></Head>
    <div class="newsDetail">
      <div class="newsContents">
        <div class="titlecontent">
          <div class="title font28">{{ contentData.title }}</div>
        </div>
        <div class='textContent' v-html="contentData.content"></div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from '../components/headercontent'
import Foot from '../components/footercontent'
import Service from '../common/service'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 引入中文语言包，根据需要选择
export default {
  name: 'home',
  data() {
    return {
      selectindex: 3,
      showLoading: true,
      contentData: [],
      id: ''
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getNews();
  },
  mounted() {
    console.log('20230410');
  },
  methods: {

    getNews() {
      Service.news().getnews({}, this.id).then(response => {
        if (response.data != null) {
          this.contentData = response.data;
          this.contentData.createDate = dayjs(response.data.createDate).locale('zh-cn').format('YYYY年M月DD日h时m分');
          console.log(this.contentData.createDate);
          this.$nextTick(() => {
            var img = $('.articleContent ').find('img')
            for (var i = 0; i < img.length; i++) {
              // console.log($(img[i]).attr("style"))
              if ($(img[i]).width() > window.screen.width) {
                $(img[i]).css("cssText", "width:100% !important;box-sizing:border-box !important;word-wrap: break-word !important;")
              } else {
                $(img[i]).css({
                  'max-width': '100%',
                  'height': 'auto'
                })
              }
            }
          })
        }
      }, err => { });
    },
    timetrans(d) {
      var getSeconds = '',
        getMinutes = '',
        getHours = '';
      getHours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
      getMinutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      getSeconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      var newTime = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日 ';
      // + getHours + ':' + getMinutes + ':' + getSeconds;
      return newTime
    },

  },
  components: {
    Head,
    Foot,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/views/newsDetail.vue